import { Injectable } from '@angular/core';

declare global {
  interface Window {
    i2gGutenberg: any;
    webkitURL: any;
    URL: any;
    Intl: any;
    Date: any;
    braintree: any;
    AppleID: any;
    FB: any;
    gapi: any;
  }
}

@Injectable({
  providedIn: 'root',
})
export class WindowRefService {
  get nativeWindow(): Window {
    return window;
  }
}
